import { computed } from "vue";
import { useStore } from "vuex";
import { useClientSide } from "@/hooks/use-client-side";
import { MODULES, vuexName } from "@/store/utils";

export const useWhiteboard = () => {
  const { getters } = useStore();
  const { isTeacherSide } = useClientSide();
  const isWbVisible = computed<boolean>(() => {
    if (isTeacherSide.value) return getters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_IS_SHOW_WHITE_BOARD)];
    return getters[vuexName(MODULES.STUDENT_ROOM.GETTERS.GET_IS_SHOW_WHITEBOARD)];
  });
  return { isWbVisible };
};
